/**
 * Original file from app_deborla cartridge
 *
 * Modifications:
 * Add carouselUtils import
 * Add Product Detail Carousel init
 *
 */

'use strict';

var base = require('./base');
var carouselUtils = require('../utils/carouselUtils');

/**
 * Registering on change event on quantity selector. If store has been selected, exist function,
 * otherwise proceed to update attributes.
 */
function availability() {
    $(document).on('change', '.quantity-select', function (e) {
        e.preventDefault();

        var searchPID = $(this).closest('.product-detail').attr('data-pid');
        var selectorPrefix = '.product-detail[data-pid="' + searchPID + '"]';

        if ($(selectorPrefix + ' .selected-store-with-inventory').is(':visible')) {
            return;
        }

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.modal-content').find('.product-quickview');
        }

        if ($('.bundle-items', $productContainer).length === 0) {
            base.attributeSelect($(e.currentTarget).find('option:selected').data('url'), $productContainer);
        }
    });
}

module.exports = {
    availability: availability,

    // START: Differs from app_deborla cartridge
    initCarousel: function () {
        $(document).ready(function () {
            carouselUtils.createProductDetailsCarousel('.hom-product-details__carousel');
        });
    },
    // END: Differs from app_deborla cartridge

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes').empty().html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description').removeClass('hidden-xl-down');
                $productContainer
                    .find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description').addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details').removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content').empty().html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details').addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                $('.product-id').text(response.data.product.id);
                $('.availability-state-trigger').data(
                    'action',
                    $('.product-id').data('action-url') + '?showMap=true&products=' + response.data.product.id + ':1'
                );
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                $('.product-id').text(response.data.product.id);
                $('.availability-state-trigger').data(
                    'action',
                    $('.product-id').data('action-url') + '?showMap=true&products=' + response.data.product.id + ':1'
                );
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
                $('.availability-state-trigger').data(
                    'action',
                    $('.product-id').data('action-url') + '?showMap=true&products=' + response.data.product.id + ':1'
                );
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr(
                'disabled',
                !response.product.readyToOrder || !response.product.available
            );

            var enable = $('.product-availability')
                .toArray()
                .every(function (item) {
                    return $(item).data('available') && $(item).data('ready-to-order');
                });
            $('button.add-to-cart-global').attr('disabled', !enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer).empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability').data('ready-to-order', allReady).data('available', allAvailable);

                $('.global-availability .availability-msg')
                    .empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },

    availabilityPDPhtlm: function () {
        $(document).ready(function () {
            if ($('.availability-state-trigger').length > 0) {
                var target = $('.availabilityContainerNew');
                var producturl = $('.product-id')[0].textContent;
                var url = $('.product-id').data('action-url') + '?showMap=true&products=' + producturl + ':1';
                $('.availability-state-trigger').data('action-url', url);
                if (url) {
                    $.ajax({
                        url: url,
                        type: 'get',
                        dataType: 'json',
                        success: function (response) {
                            target.html(response.storesPDPResultsHtml);
                        }
                    });
                }
            }
        });
    },

    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal()
};
